import { Modal } from '@/components';

import TotpEnroll from './TotpEnroll';

type TotpEnrollModalProps = {
  qrCode: string;
  url: string;
  onClose: () => void;
  onConfirmed?: (recoveryCodes: string[]) => void | Promise<void>;
};

/** Modal host for {@link TotpEnroll}. The screen renders its own heading, so the
 *  modal needs no title — just the close affordance and the shared content. */
const TotpEnrollModal = ({ qrCode, url, onClose, onConfirmed }: TotpEnrollModalProps) => (
  <Modal open onClose={onClose}>
    <TotpEnroll qrCode={qrCode} url={url} onConfirmed={onConfirmed} onDone={onClose} />
  </Modal>
);

export default TotpEnrollModal;
